/**
 * @author Maxime Mustarda <maxime@inarix.com>
 * @file LicenseFilterBtns.tsx
 * @desc Created on Thu May 15 2025 20:59:07
 * @copyright All rights reserved @ Inarix
 */

import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box, Stack } from "@mui/material";
import { RemoveRedEye } from "@mui/icons-material";
import {
  selectAvailPackCount,
  selectExpiringCount,
  selectLowOrEmptyCount,
  selectUnassignedCount,
  toggleUnassigned,
} from "../../redux/slices/licenses/licenseList";

enum Colors {
  green = "#4CAF50",
  blue = "#3478F6",
  red = "#E57373",
  orange = "#FF9800",
  grey = "rgba(33, 29, 38, .38)",
}

const FilterButton: FC<{
  title: string;
  value: number;
  color: Colors;
  emptyColor?: Colors;
  handler?: () => void;
}> = ({ handler, title, value, color, emptyColor }) => (
  <Box onClick={handler} sx={{ cursor: handler ? "pointer" : "default" }}>
    <Stack direction="row">
      <h6>{title}</h6>
      {handler ? <RemoveRedEye className="license-eye" /> : null}
    </Stack>
    <h3
      style={{
        color: value == 0 ? emptyColor || color : color,
      }}
    >
      {value}
    </h3>
  </Box>
);

export function LicenseFilterBtns() {
  const [t] = useTranslation("global");
  const unassignedCount = useSelector(selectUnassignedCount);
  const lowOrEmptyCount = useSelector(selectLowOrEmptyCount);
  const expiringCount = useSelector(selectExpiringCount);
  const availPackCount = useSelector(selectAvailPackCount);
  const dispatch = useDispatch();

  return (
    <div className="license-filter-buttons">
      <div className="license-filter-buttons-child">
        <FilterButton
          color={Colors.blue}
          emptyColor={Colors.grey}
          title={t("licenses.unassigned")}
          value={unassignedCount}
          handler={() => dispatch(toggleUnassigned())}
        />
        <FilterButton
          color={Colors.orange}
          emptyColor={Colors.green}
          title={t("licenses.lowOrEmpty")}
          value={lowOrEmptyCount}
        />
        <FilterButton
          color={Colors.red}
          title={t("licenses.expSoon")}
          value={expiringCount}
        />
        <FilterButton
          color={Colors.green}
          emptyColor={Colors.grey}
          title={t("licenses.availPacks")}
          value={availPackCount}
        />
      </div>
    </div>
  );
}
